module.exports = __webpack_public_path__ + "static/img/icon_footer.2c7c679.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_footer.png
// module id = FJJe
// module chunks = 34